import columns from './utils/columns'

const state = () => ({
  columns,
  idToken: null,
})

export default state
